/**
 * Created by Ning Jiang on 2021-05-28.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {TombstoneRip} from "../../TombstoneRip";
import {TombstoneScatter} from "../../symbol/TombstoneScatter";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ScatterLandingView} from "./ScatterLandingView";
import {TombstoneRipSound} from "../../sound/TombstoneRipSound";
import {TombstoneRipBackground} from "../../view/TombstoneRipBackground";

export class ScatterLandingController extends ReelStopPresentationController {

    private _view:ScatterLandingView;
    private _scatters:TombstoneScatter[] = [];

    constructor() {
        super("ScatterLandingController");
        this._view = new ScatterLandingView();
        TombstoneRip.scatters = this;
    }

    protected onReelStopped(data:IReelStateEventData):Promise<any> {
        const gameData = TombstoneRip.model.parsedGameData;
        const scatterPosition = gameData.scatterPositions![data.reelId];
        if(scatterPosition === -1) {
            if(data.reelId === 3 || data.reelId === 4) {
                this._scatters.forEach(scatter => {
                    scatter.stopNearWin();
                });
                this._view.stopNearWin(true);
            }
            return Promise.resolve();
        }

        // Always play on S2.
        if(data.reelId === 4) {
            TombstoneRipBackground.shakeStageOnce();
            this._view.stopNearWin(false);
            const S2 = <TombstoneScatter>TombstoneRip.reels[4].getSymbol(0);
            this._scatters.push(S2);

            // win super fs
            if(gameData.freespinTriggeredThisSpin) {
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SCATTER_LAND_4});
                return Promise.all([
                    S2.playLanding(),
                    S2.playWin(true, 0.633)
                ]);
            }
            // upgrade to super fs.
            if(gameData.mode === GameMode.FREESPIN) {
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SCATTER_LAND_4});
                return Promise.all([
                    S2.playLanding(),
                    S2.playWin(true)
                ]);
            }

            // main game S2 feature
            if(TombstoneRip.model.parsedGameData.superFSInfo.respinReel5) {
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.RESPIN_S2_LAND});
            } else {
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.RESPIN_S2_LAND_NO_RESPIN});
            }

            return Promise.resolve(S2.playLanding());
        }

        this._scatters.push(<TombstoneScatter>TombstoneRip.reels[data.reelId].getSymbol(scatterPosition));

        switch(this._scatters.length) {
            case 1:
                // first scatter
                if(data.reelId < 3) {
                    TombstoneRipSound.soundPlayer.playTrack({
                        name : data.reelId === 1 && TombstoneRip.xBetController.selected ?
                            TombstoneRipSound.SCATTER_LAND_1_ENHANCED : TombstoneRipSound.SCATTER_LAND_1
                    });
                }
                return Promise.resolve(this._scatters[0].playLanding(data.reelId === 1 && TombstoneRip.xBetController.selected));
            case 2:
                // second scatter
                // on reel 2, start near win, play effect level 1 loop on both scatters.
                // on reel 3, (play effect level 1 no loop on both scatters?). later change to WRS symbol,
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SCATTER_LAND_2});
                const animations2:any[] = [
                    this._scatters[1].playLanding(),
                    this._scatters[0].playBlood(),
                    this._scatters[1].playBlood()
                ];
                if(data.reelId === 2) {
                    animations2.push(
                        this._scatters[0].playNearWin(),
                        this._scatters[1].playNearWin()
                    );
                    if(!TombstoneRip.reels[2].isQuickStop && !TombstoneRip.model.parsedGameData.wasFeatureBuy) {
                        // start near win on reel 3
                        animations2.push(this._view.playNearWin4());
                    }
                }

                return Promise.all(animations2);
            case 3:
                // win fs, this can only happen on reel 3
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SCATTER_LAND_3});
                TombstoneRipSound.soundPlayer.playTrack({
                    name : TombstoneRipSound.REELS_ON_FIRE,
                    volume : 1,
                    repeat : 100
                });
                const animations3:any[] = [
                    this._scatters[2].playLanding(),
                    this._scatters[2].playBlood(),
                    this._scatters[0].playNoose(0.633),
                    this._scatters[1].playNoose(0.633),
                    this._scatters[2].playNoose(0.633),
                    this._scatters[0].playWin(true),
                    this._scatters[1].playWin(true),
                    this._scatters[2].playWin(true)
                ]
                if(!TombstoneRip.reels[3].isQuickStop && !TombstoneRip.model.parsedGameData.wasFeatureBuy) {
                    animations3.push(
                        this._view.playNearWin5()
                    );
                }
                return Promise.all(animations3);
            default:
                debugger;
                throw new Error("Scatter count wrong!");
        }
    }

    public stopAllScatters():void {
        this._scatters.forEach(scatter => {
            scatter.stopWin();
        });
        TombstoneRipSound.fadeAndStopSound({
            name : TombstoneRipSound.REELS_ON_FIRE,
            to : 0,
            duration : 200
        });
    }

    protected reset() {
        super.reset();
        this._scatters = [];
    }
}